
import axios from 'axios'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Selector from 'vux/src/components/selector/index.vue'

import { Debounce } from '../utils'
import Bus from '../bus'
import Disclaimer from './Disclaimer'
export default {
name:'AddForm',
directives: {
TransferDom
},
components:{
TransferDom, XDialog, Group, XInput, XTextarea, XButton, Flexbox, FlexboxItem, Toast, Grid, GridItem, Selector,Disclaimer
},
props:['showmodal','type'],
watch:{
showmodal(v){
var el = document.getElementById('app')
this.scrollTop = v ? document.documentElement.scrollTop : this.scrollTop
el.hidden = v
if (!v) {
setTimeout(() => {
window.scrollTo({top:this.scrollTop||0, left:0})
}, 200)
}
},
},
data(){
return {
originatorNameText:'',
materialNameText:'',
entNameText:'',
enterpriseName:'',
name:'',
location:'',
phone:'',
nameIcon:'',
orgnameIcon:'',
locationIcon:'',
phoneIcon:'',
isToast: false,
toastMsg: '提交成功',
toastType: 'success',
pg2del: require('../assets/del.png'),
systemId: '',
list: [
{key: 'N95医用防护口罩（GB 19083-2010）及以上', value: 'N95医用防护口罩（GB 19083-2010）及以上'},
{key: '医用外科口罩（YY0469-2011)及以上', value: '医用外科口罩（YY0469-2011)及以上'},
{key: '防护服（GB 19082-2003）及以上', value: '防护服（GB 19082-2003）及以上'},
{key: '护目镜', value: '护目镜'},
{key: '医用帽', value: '医用帽'},
{key: '一次性手术衣', value: '一次性手术衣'},
{key: '医用一次性乳胶手套（GB 10213-2006）', value: '医用一次性乳胶手套（GB 10213-2006）'},
{key: '防冲击眼罩', value: '防冲击眼罩'},
{key: '防护面罩', value: '防护面罩'},
{key: '隔离衣', value: '隔离衣'},
{key: 'N95口罩', value: 'N95口罩'},
{key: 'KN95口罩', value: 'KN95口罩'},
{key: '其他防护物品', value: '其他防护物品'}
],
materialist:[
{materialClassName:'',materialNum:'',materialDesc:''}
]
}
},
methods:{
ModalHelper: () =>{

let bodyCls = 'dialog-open'
let scrollTop;
return {
afterOpen: function () {
scrollTop = document.scrollingElement.scrollTop;
document.body.classList.add(bodyCls);
document.body.style.top = -scrollTop + 'px';
},
beforeClose: function () {
document.body.classList.remove(bodyCls);
}
};
},
setIconType (v, icon) {
if (v == "") {
this[icon] = "error"
} else {
this[icon] = "success"
}
},
submit: Debounce(function () {

const _this = this;
if (this.enterpriseName == "") {
this.orgnameIcon = "error"
return
}
if (this.location == "") {
this.locationIcon = "error"
return
}
if (this.name == "") {
this.nameIcon = "error"
return
}
if (this.phone == "") {
this.phoneIcon = "error"
this.toastType = "text"
return
}
axios.post('/yuncai-yop/contribute/save', {
enterpriseName: this.enterpriseName,
name: this.name,
phone: this.phone,
location: this.location,
details: this.materialist,
systemId: this.systemId,
type:this.type
}).then(function (res) {
_this.isToast = true
_this.toastMsg = "提交成功,信息需经平台审核通过后方可公布出来"
_this.toastType = "success"
Bus.$emit("close-modal",!_this.showmodal)
}).catch((function (err) {
_this.isToast = true
_this.toastMsg = "提交失败"
_this.toastType = "warn"
}))
}, 3000),
close () {
Bus.$emit("close-modal",!this.showmodal)
},
toastHide () {
if (this.toastType !== "text") {
this.enterpriseName = ''
this.name = ''
this.phone = ''
this.location = ''
this.materialist = [{materialClassName:'',materialNum:'',materialDesc:''}]
}
},
addmaterial (){
this.materialist.push({materialClassName:'',materialNum:'',materialDesc:''})
},
del (index){
this.materialist.splice(index,1)
console.log(this.materialist)
}
},
mounted () {
var tag = window.location.search.split('=')[1]
if(tag && tag.includes('hzh')){

this.systemId = 1
}else{

this.systemId = 0
}

switch(this.type){
case 4:
this.originatorNameText = '募捐人信息'
this.materialNameText = '募捐物资信息'
this.entNameText = '供应商'
break;
case 6:
this.originatorNameText = '捐赠人信息'
this.materialNameText = '捐赠物资信息'
this.entNameText = '募捐方'
break;
case 8:
this.originatorNameText = '供货人信息'
this.materialNameText = '供应物资信息'
this.entNameText = '需求方'
break;
case 10:
this.originatorNameText = '需求人信息'
this.materialNameText = '需求物资信息'
this.entNameText = '供应商'
break;
}
}
}



// WEBPACK FOOTER //
// ./src/components/AddForm.vue